import { useState } from "react";
import { useSelector } from "react-redux";
import logo from "../assets/icons/logo.svg";
import Button from "./button";
import { Link } from "react-router-dom";
import menu from "../assets/icons/menu.svg";
import close from "../assets/icons/close.svg";
import arrow from "../assets/icons/iconlyArrow.svg";

const Navbar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleMenu = () => setIsVisible(!isVisible);

  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

  return (
    <div>
      <div className="bg-white py-4 md:py-3 px-4 md:px-12 border-b flex justify-between items-center fixed top-0 w-full z-50">
        {isAuthenticated ? (
          <Link to="/dashboard" className="py-3 md:py-0">
            <img src={logo} alt="" className="h-5" />
          </Link>
        ) : (
          <Link to="/" className="py-3 md:py-0">
            <img src={logo} alt="" className="h-5" />
          </Link>
        )}

        {!isAuthenticated ? (
          <div className="hidden md:flex gap-4 items-center">
            <Button
              buttonText={"Discover campaigns"}
              buttonRole={"link"}
              destination={"/all-campaigns"}
            />
            <Button
              buttonText={"How it works"}
              buttonRole={"link"}
              destination={"/how-it-works"}
            />
            {/* <Button
              buttonText={"Sign in"}
              buttonRole={"link"}
              destination={"/sign-in"}
            /> */}
            <Button
              buttonText={"Sign in"}
              buttonRole={"link"}
              destination={"/sign-in"}
              otherStyles={"bg-black text-white"}
              icon={arrow}
            />
          </div>
        ) : (
          <div className=" hidden md:block">
            <Button
              buttonText={"Back to dashboard"}
              buttonRole={"link"}
              destination={"/dashboard"}
              otherStyles={"bg-black text-white"}
              icon={arrow}
            />
          </div>
        )}

        {
          isAuthenticated ? null : 
          <div className="md:hidden" onClick={toggleMenu}>
          <img src={menu} alt="" className="h-5" />
        </div>
        }
      </div>

      {/* small screen menu */}
      {isVisible && (
        <div
          className="bg-black/80 fixed top-0 z-50 w-full h-screen transition-all duration-300 flex md:hidden">
          <div className="p-4 md:p-8 bg-white w-full">
            <div className="grid">
              <div className="flex justify-end">
                <span
                  className="rounded p-2 cursor-pointer"
                  onClick={toggleMenu}
                >
                  <img src={close} alt="" className="h-5" />
                </span>
              </div>
              <div className="grid mb-4 md:mb-0">
                <Link
                  to="/all-campaigns"
                  onClick={toggleMenu}
                  className="py-6 border-b"
                >
                  Discover campaigns
                </Link>
                <Link
                  to="/how-it-works"
                  onClick={toggleMenu}
                  className="py-6 border-b"
                >
                  How it works
                </Link>
                {/* <Link
                  to="/sign-in"
                  onClick={toggleMenu}
                  className="py-6 border-b mb-8"
                >
                  Sign in
                </Link> */}
                <Button
                  buttonText={"Sign in"}
                  buttonRole={"link"}
                  destination={"/sign-in"}
                  otherStyles={"bg-black text-white"}
                  icon={arrow}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
